import Vue, { Component } from 'vue';
import { Component as ComponentDecorator } from 'vue-property-decorator';

@ComponentDecorator({
  props: {
    socialIcons: Array,
  },
})

export default class CubeFooter extends Vue {
}
